import { useEffect } from "react";
import { Link } from "react-router-dom";
import { Bell, Megaphone, Hourglass, CheckCircle2, XCircle, Printer } from "lucide-react";
import { MTopBar } from "@/components/mobile/MTopBar";
import { MPage, EmptyArt, cardCls } from "@/components/mobile/parts";
import { useMobile } from "@/context/MobileContext";
import { fmtDateTime } from "@/lib/api";
import { cn } from "@/lib/utils";

const ICONS = { aviso: [Megaphone, "text-[#1565c0] bg-[#e3f2fd]"], liberacao: [Hourglass, "text-amber-700 bg-amber-100"], aprovado: [CheckCircle2, "text-emerald-700 bg-emerald-100"], recusado: [XCircle, "text-red-700 bg-red-100"], impressao: [Printer, "text-red-700 bg-red-100"] };

function Item({ n }) {
  const [Icon, cls] = ICONS[n.kind] || ICONS.aviso;
  const body = (
    <div className={cn(cardCls, "flex items-start gap-3 p-3")} data-testid={`m-notif-${n.id}`}>
      <span className={cn("grid h-10 w-10 shrink-0 place-items-center rounded-xl", cls)}><Icon className="h-5 w-5" /></span>
      <div className="min-w-0 flex-1">
        <p className="text-sm font-semibold">{n.title}</p>
        {n.text && <p className="whitespace-pre-line text-sm text-slate-600">{n.text}</p>}
        <p className="text-xs text-slate-400">{fmtDateTime(n.at)}</p>
      </div>
    </div>
  );
  return n.link ? <Link to={n.link} className="block">{body}</Link> : body;
}

export default function MNotifications() {
  const { notifs, markSeen } = useMobile();
  useEffect(() => { markSeen(); }, [markSeen, notifs.length]);
  return (
    <>
      <MTopBar title="Histórico Notificações" back />
      <MPage>
        <p className="text-xs text-slate-500">Avisos do sistema, liberações e falhas de impressão dos últimos 7 dias.</p>
        {!notifs.length ? <EmptyArt icon={Bell} title="Nenhuma notificação" testId="m-notifs-empty" /> : <div className="space-y-2" data-testid="m-notifs-list">{notifs.map((n) => <Item key={n.id} n={n} />)}</div>}
      </MPage>
    </>
  );
}
